import { Share2 } from "lucide-react";
import { toast } from "sonner";

export function ShareAlbum({ album }) {
  const share = async () => {
    const url = `${window.location.origin}/community-wall?album=${album.id}`;
    const text = `Memories from ${album.title} — The Jenova Girls Experience`;
    if (navigator.share) {
      try {
        await navigator.share({ title: album.title, text, url });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Album link copied — paste it anywhere to share");
    } catch {
      window.prompt("Copy this album link", url);
    }
  };
  return (
    <button className="jc-btn jc-btn-ghost mt-6" onClick={share} data-testid="wall-share-album-btn">
      <Share2 className="w-4 h-4" strokeWidth={1.25} /> Share album
    </button>
  );
}
